import { InjectionKey } from 'vue'
import { createI18n } from 'vue-i18n'
import { createStore, Store } from 'vuex'
import axios from 'axios'

interface I18nState {
  current: string
  default: string
  loading: boolean
}

export const key: InjectionKey<Store<I18nState>> = Symbol('store')

export const i18n = createI18n({
  legacy: false,
})

const loadedLanguages: string[] = []

export const store = createStore<I18nState>({
  strict: true,
  state: {
    current: '',
    default: '',
    loading: true,
  },
  actions: {
    async init({ commit, dispatch }) {
      commit('setLoading', true)
      const { data } = await axios.get(`${document.location.origin}${window.BASE_URI}api/config/language`)
      await dispatch('setLanguage', data.current)
      await commit('setDefault', data.default)
      commit('setLoading', false)
    },
    async setLanguage({ commit }, lang: string) {
      if (!loadedLanguages.includes(lang)) {
        const { data } = await axios.get(`${document.location.origin}${window.BASE_URI}lang/${lang}.json`, {
          params: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            v: window.VERSION,
          },
        })
        i18n.global.setLocaleMessage(lang, data.messages)
        if (data.dateTimeFormats) {
          i18n.global.setDateTimeFormat(lang, data.dateTimeFormats)
        }
        loadedLanguages.push(lang)
      }
      commit('setLanguage', lang)
    },
  },
  mutations: {
    setLoading: (state, loading = false) => {
      state.loading = loading
    },
    setDefault: (state, lang: string) => {
      state.default = lang
    },
    setLanguage: (state, lang: string) => {
      state.current = lang
      // eslint-disable-next-line no-param-reassign
      i18n.global.locale.value = lang
      // eslint-disable-next-line no-unused-expressions
      document.querySelector('html')?.setAttribute('lang', lang)
    },
  },
})
